import { FC, useEffect } from "react";
import { useParams } from "react-router-dom";
import Introduction from "./Introduction";
import FirstNotification from "./Subsection1";
import Seriousness from "./Subsection2";
import CounterofferNotification from "./Subsection3";
import TextBasedResponses from "./Subsection4";
import BreadcrumbNav from "../../navigation/Breadcrumb";
import BottomNavigation from "../../navigation/BottomNavigation";

interface NegotiationProcessProps {
  toggleSection: (section: string, open?: boolean) => void;
}

const NegotiationProcess: FC<NegotiationProcessProps> = ({ toggleSection }) => {
  const { subsection } = useParams();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [subsection]);

  useEffect(() => {
    toggleSection("The Negotiation Process", true);
  }, [toggleSection])

  return (
    <>
      <BreadcrumbNav section="negotiation-process" subsection={subsection} />

      <h1>The Negotiation Process</h1>
      {subsection === "introduction" && <Introduction />}
      {subsection === "first-notification" && <FirstNotification />}
      {subsection === "seriousness" && <Seriousness />}
      {subsection === "counteroffer-notification" && <CounterofferNotification />}
      {subsection === "your-institutions-handling-of-process" && <TextBasedResponses />}

      <BottomNavigation />
    </>
  )
}

export default NegotiationProcess;